export default function getOfferKey(orderId: string, orderRoleId: string) {
    return `${ orderId }-${ orderRoleId }`;
}
